export function FulltextFilter({onChange, placeholder}) {
    return (
        <div className="d-flex align-items-center position-relative my-1">
            <i className="ki-duotone ki-magnifier fs-3 position-absolute ms-5">
                <span className="path1"></span>
                <span className="path2"></span>
            </i>
            <input
                type="text"
                data-kt-customer-table-filter="search"
                className="form-control form-control-solid ps-12"
                placeholder={placeholder}
                onChange={onChange}
            />
        </div>
    )
}